import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import * as config from '../backend.config';
import { TokenStorageService } from '../authentication/token-storage.service';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';

const ADDRS_APIWS = config.APIWS;

@Injectable({
  providedIn: 'root'
})

export class SignalrService {
  hubUrl: string;
  public data: any;
  private hubConnection: signalR.HubConnection;
  audio = new Audio();
  public newConversionActivated = new Subject();
  id: number;
  accessToken: string | null;

  constructor(private tokentstorageService: TokenStorageService,
              private toastrService: ToastrService
              ) {
    this.hubUrl = ADDRS_APIWS;
  }

  public startConnection = () => {
    this.hubConnection = new signalR.HubConnectionBuilder()
                            .withUrl(this.hubUrl, {
                              accessTokenFactory: () => this.tokentstorageService.getToken()!,
                              skipNegotiation: true,
                              transport: signalR.HttpTransportType.WebSockets
                              })
                            .withAutomaticReconnect()
                            .build();
    this.hubConnection
      .start()
      .then(() => console.log('Connection started:'))
      .catch(err => console.log('Error while starting connection: ' + err))
  }

  public newConversionListener = () => {

     this.hubConnection.on('NewConversionAppeared', (data) => {
       this.data = data;
       this.toastrService.info(`New payout <b>${data.revenue} $</b> from ` + data.country.name, 'Conversion came in !',
       {enableHtml: true});
       this.audio.src="../../../../assets/sound/conversion.wav";
       this.audio.load();
       this.audio.play();
       this.id=1;
       this.newConversionActivated.next(this.id);
       // wskazuje na jakiej stronie jestem
       // wymaga dodania import { Router } from '@angular/router';
       // oraz do construktora
       //console.log(this.router.url)
     });
    }

  public getConnectionState(){
    if (this.hubConnection.state === signalR.HubConnectionState.Disconnected)
    {
      console.log("websocket DISCONECTED !");
    }
    else {
      console.log("websocket works ! ", this.hubConnection.state);
    }
    return this.hubConnection.state;
  }

  public stopConnection(): void {
      if (this.hubConnection) {
        this.hubConnection.stop();
      }
    }

  // wysyłanie do huba czegoś
  // public userPing( userName): void {
  //   if (this.hubConnection.state === signalR.HubConnectionState.Connected){
  //     this.hubConnection
  //     .invoke('UserRegister', userName)
  //     .catch(err => console.error('userPing error:', err));
  //   }
  // }
  /**
  * Close connection
  */
}
